/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Directive, EventEmitter, HostBinding, HostListener, Input, Output} from '@angular/core';

// Small hack to make Jest behave itself
type DragEvent = any;

@Directive({
    selector: '[appDragAndDrop]',
    standalone: false
})
export class DragAndDropDirective {

    @Output() fileDrop = new EventEmitter<File[]>();
    @Input() disabled: boolean;
    @HostBinding('class.fileover') fileOver: boolean;

    // Dragover listener
    @HostListener('dragover', ['$event'])
    onDragOver(event: DragEvent): void {
        event.preventDefault();
        event.stopPropagation();
        if (!this.disabled) {
            this.fileOver = true;
        }
    }

    // Dragleave listener
    @HostListener('dragleave', ['$event'])
    onDragLeave(event: DragEvent): void {
        event.preventDefault();
        event.stopPropagation();
        if (!this.disabled) {
            this.fileOver = false;
        }
    }

    // Drop listener
    @HostListener('drop', ['$event'])
    public onDrop(event: DragEvent): void {
        event.preventDefault();
        event.stopPropagation();
        if (!this.disabled) {
            const {dataTransfer}: DragEvent = event;
            this.fileOver = false;

            if (dataTransfer.items != null) {
                const files: File[] = [];

                for (let index = 0; index < dataTransfer.items.length; index++) {
                    const item = dataTransfer.items[index];

                    if (item.kind === 'file') {
                        files.push(item.getAsFile());
                    }
                }

                this.fileDrop.emit(files);
            }
        }
    }
}
